import { BrowserRouter, Route, Routes } from "react-router-dom";
import AdminLoginScreen from "../screens/admin-login-screen";
import RequireAuth from "../routes/ProtectedRoute";
import RegisterScreen from "../screens/register-screen";

import {
  APPOINTMENTS_SCREEN_ROUTE,
  LOGIN_SCREEN_ROUTE,
  REGISTER_SCREEN_ROUTE,
  OTP_SCREEN_ROUTE,
  START_SCREEN_ROUTE,
  DASHBOARD_SCREEN_ROUTE,
  DOCTOR_DASHBOARD_SCREEN_ROUTE,
  STAFF_DASHBOARD_SCREEN_ROUTE,
  APPOINTMENT_REQUEST_ROUTE,
  SPECIALITY_SCREEN_ROUTE,
  DOCTOR_REFFERALS_ROUTE,
  BANKDETAILS_SCREEN_ROUTE,
  PATIENTS_SCREEN_ROUTE,
  DOCTOR_LOGIN_SCREEN_ROUTE,
  MANUFACTURER_DASHBOARD_SCREEN_ROUTE,
  SALESHISTORY_DASHBOARD_SCREEN_ROUTE,
  NEWSALE_DASHBOARD_SCREEN_ROUTE,
  BATCH_DASHBOARD_SCREEN_ROUTE,
  PURCHASES_DASHBOARD_SCREEN_ROUTE,
  MEDICINES_DASHBOARD_SCREEN_ROUTE,
  SUPPLIER_DASHBOARD_SCREEN_ROUTE,
  CATEGORY_DASHBOARD_SCREEN_ROUTE,
  MEDICINEFORMULA_DASHBOARD_SCREEN_ROUTE,
  STAFFMANAGEMENT_DASHBOARD_SCREEN_ROUTE,
  SHIFTMANAGEMENT_DASHBOARD_SCREEN_ROUTE,
  SHIFTMANAGEMENT_DASHBOARD_USER_SCREEN_ROUTE,
  CHECKOUT_DASHBOARD_SCREEN_ROUTE,
  STAFF_PROFILE_SCREEN_ROUTE,
  GETTECHINAL_DASHBOARD_SCREEN_ROUTE,
  RETURNITEM_DASHBOARD_SCREEN_ROUTE,
  RETURNHISTORY_DASHBOARD_SCREEN_ROUTE,
  NONMEDICINES_DASHBOARD_SCREEN_ROUTE,
  CHANGE_PASSWORD_SCREEN_ROUTE,
  SIGNUP_SCREEN_ROUTE,
  RETURN_POLICY_SCREEN_ROUTE,
  EXPENSE_SCREEN_ROUTE,
  EXPENSE_CATEGORY_SCREEN_ROUTE,
  ORDER_PURCHASE_SCREEN_ROUTE,
  SHELF_DASHBOARD_SCREEN_ROUTE,
  PRODUCTSALESHISTORY_DASHBOARD_SCREEN_ROUTE,
  CUSTOMER_HISTORY_SCREEN_ROUTE

} from "../routes";
import NotFound from "../screens/404";

import StartScreen from "../screens/start-screen";
import PublicRoutes from "../routes/PublicRoutes";

import DoctorDashboardScreen from "../screens/doctor-dashboard-screen";
import StaffDashboardScreen from "../screens/staff-dashboard-screen";
import DashBoard from "../screens/dashboard";

import SpecialityScreens from "../screens/specialitys-screen";

import PatientScreen from "../screens/patientsScreen";

import DoctorLogin from "../screens/doctorLogin";
import Manufacturer from "../screens/manufacturer";
import NewSale from "../screens/newsale";
import SalesHistory from "../screens/saleshistory";
import Batch from "../screens/batch";
import Purchases from "../screens/purchases";
import Medicines from "../screens/medicines";
import NonMedicines from "../screens/nonmedical";

import Supplier from "../screens/supplier";
import Category from "../screens/category";
import UserManagement from "../screens/staff-profile-screen";
import MedicineFormula from "../screens/medicineformula";
import LoginScreen from "../screens/login-screen";
import OTPScreen from "../screens/otp-screen";
import StaffProfileScreen from "../screens/staff-profile-screen";
import StaffScreen from "../screens/staff-screen";
import GetTechnicalHelp from "../screens/getTechnicalHelp";
import ReturnItem from "../screens/returnItem";
import ReturnHistory from "../screens/returnHistory";
import ShiftScreen from "../screens/shift-screen";
import ShiftUserScreen from "../screens/shift-user-screen";
import ChangePassword from "../screens/change-password";
import ReturnPolicy from "../screens/return-policy";
import SignUpScreen from "../screens/signup-screen";
import DailyExpense from "../screens/daily-expenses";
import ExpenseCategory from "../screens/expenseCategory";
import Expenses from "../screens/daily-expenses";
import OrderPurchase from "../screens/order-purchase";
import ShelfScreen from "../screens/shelfScreen";
import ProductSalesHistory from "../screens/productSalesHistory";
import CustomerHistoryScreen from "../screens/customer-history-screen";
function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route element={<RequireAuth />}>
          <Route path={DASHBOARD_SCREEN_ROUTE} element={<DashBoard />} />
          <Route path={NEWSALE_DASHBOARD_SCREEN_ROUTE} element={<NewSale />} />
          <Route
            path={RETURNITEM_DASHBOARD_SCREEN_ROUTE}
            element={<ReturnItem />}
          />

          <Route
            path={SALESHISTORY_DASHBOARD_SCREEN_ROUTE}
            element={<SalesHistory />}
          />
          <Route path={EXPENSE_SCREEN_ROUTE} element={<Expenses />} />
          <Route
            path={EXPENSE_CATEGORY_SCREEN_ROUTE}
            element={<ExpenseCategory />}
          />
          <Route
            path={RETURNHISTORY_DASHBOARD_SCREEN_ROUTE}
            element={<ReturnHistory />}
          />
          <Route
            path={PRODUCTSALESHISTORY_DASHBOARD_SCREEN_ROUTE}
            element={<ProductSalesHistory />}
          />

          <Route
            path={BATCH_DASHBOARD_SCREEN_ROUTE}
            element={<Batch getMedicine />}
          />
          <Route
            path={ORDER_PURCHASE_SCREEN_ROUTE}
            element={<OrderPurchase  />}
          />
          <Route
            path={PURCHASES_DASHBOARD_SCREEN_ROUTE}
            element={<Purchases getMedicine />}
          />
          <Route
            path={MEDICINES_DASHBOARD_SCREEN_ROUTE}
            element={<Medicines />}
          />
          <Route
            path={SHELF_DASHBOARD_SCREEN_ROUTE}
            element={<ShelfScreen />}
          />
          <Route
            path={CUSTOMER_HISTORY_SCREEN_ROUTE}
            element={<CustomerHistoryScreen />}
          />
          <Route
            path={NONMEDICINES_DASHBOARD_SCREEN_ROUTE}
            element={<NonMedicines />}
          />
          <Route
            path={SUPPLIER_DASHBOARD_SCREEN_ROUTE}
            element={<Supplier supplier />}
          />
          <Route
            path={CATEGORY_DASHBOARD_SCREEN_ROUTE}
            element={<Category />}
          />
          <Route
            path={MEDICINEFORMULA_DASHBOARD_SCREEN_ROUTE}
            element={<MedicineFormula />}
          />
          <Route
            path={MANUFACTURER_DASHBOARD_SCREEN_ROUTE}
            element={<Manufacturer />}
          />
          <Route
            path={STAFFMANAGEMENT_DASHBOARD_SCREEN_ROUTE}
            element={<StaffScreen />}
          />
          <Route
            path={SHIFTMANAGEMENT_DASHBOARD_SCREEN_ROUTE}
            element={<ShiftScreen />}
          />
          <Route
            path={CHANGE_PASSWORD_SCREEN_ROUTE}
            element={<ChangePassword />}
          />
          <Route path={RETURN_POLICY_SCREEN_ROUTE} element={<ReturnPolicy />} />

          <Route
            path={SHIFTMANAGEMENT_DASHBOARD_USER_SCREEN_ROUTE}
            element={<ShiftUserScreen />}
          />
          <Route
            path={GETTECHINAL_DASHBOARD_SCREEN_ROUTE}
            element={<GetTechnicalHelp />}
          />

          <Route
            path={STAFF_PROFILE_SCREEN_ROUTE}
            element={<StaffProfileScreen />}
          />
          <Route
            path={STAFF_DASHBOARD_SCREEN_ROUTE}
            element={<StaffDashboardScreen />}
          />

          <Route
            path={SPECIALITY_SCREEN_ROUTE}
            element={<SpecialityScreens />}
          />

          <Route path={PATIENTS_SCREEN_ROUTE} element={<PatientScreen />} />

          <Route path={DOCTOR_LOGIN_SCREEN_ROUTE} element={<DoctorLogin />} />
        </Route>

        {/* <Route element={<PublicRoutes />}>
          <Route path={START_SCREEN_ROUTE} element={<StartScreen />} />
          <Route path={LOGIN_SCREEN_ROUTE} element={<AdminLoginScreen />} />
          <Route path={REGISTER_SCREEN_ROUTE} element={<RegisterScreen />} />
        </Route> */}

        <Route element={<PublicRoutes />}>
          <Route path={START_SCREEN_ROUTE} element={<StartScreen />} />
          <Route path={LOGIN_SCREEN_ROUTE} element={<LoginScreen />} />
          <Route path={OTP_SCREEN_ROUTE} element={<OTPScreen />} />
        </Route>

        <Route path={SIGNUP_SCREEN_ROUTE} element={<SignUpScreen />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
